export const GUDHUB_SETTINGS = {
  /*------------------------- SERVER's URL -----------------------*/
  server_url: GUDHUB_SERVER_API_SCHEME + '://' + GUDHUB_SERVER_API_HOST + ':' + GUDHUB_SERVER_API_PORT + '/' + GUDHUB_SERVER_API_PATH,
  ws_url: 'wss://' + GUDHUB_SERVER_API_HOST + ':' + GUDHUB_SERVER_API_PORT + '/' + GUDHUB_SERVER_API_PATH,
  node_services_api_path: GUDHUB_NODE_SERVICES_SCHEME + '://' + GUDHUB_NODE_SERVICES_HOST + ':' + GUDHUB_NODE_SERVICES_PORT + GUDHUB_NODE_SERVICES_API_PATH,
  node_services_host: GUDHUB_NODE_SERVICES_SCHEME + '://' + GUDHUB_NODE_SERVICES_HOST,
  file_server_url: GUDHUB_FILE_SERVER_SCHEME + '://' + GUDHUB_FILE_SERVER_HOST + ':' + GUDHUB_FILE_SERVER_PORT,
  async_modules_path: 'build/' + GUDHUB_VERSION + '/async_modules/',
  automation_modules_path: 'build/' + GUDHUB_VERSION + '/automation_modules/',
  /*------------------------- DEVELOPMENT MODE -----------------------*/
  /*-- In dev mode we don't remove directives tag*/
  app_help: {
      app_id: 26750,
      field_id_map: 702554,
      field_id_link: 603747,
      field_id_parent: 603748,
      field_id_slug: 603745
  },
  maxDuplicatedFiles: 10,
  development_mode: GUDHUB_SETTINGS_DEVELOPMENT_MODE,
  show_context_menu: GUDHUB_SETTINGS_SHOW_CONTEXT_MENU,
  enable_websockets: ENABLE_WEBSOCKETS == WEBPACK_DEFINE_PLUGIN_TRUE,
  log: {
    /*-- main.js*/
    MainCtrl: true,
    /*-- app/app_controller.js*/
    ApplicationCtrl: true,
    /*-- app/data_interpreter.js*/
    interpritate: true,
    /*-- apps_manager/app_processor.js*/
    appsStorage: true,
    /*-- apps_manager/applications_contrl.js*/
    HomePageCtrl: true,
    /*-- web/web_pages_contrl.js*/
    WebPageCtrl: true,
    /*-- apps_manager/app_processor.js*/
    appDataProcesingService: true,
    applicationApi: true,
    /*-- apps_manager/file_manager.js*/
    fileStorage: true,
    fileManager: true,
    /*-- app/form/form_controller.js*/
    FormCtrl: true,
    formService: true,
    FormDirectives: true,
    /*-- app/form/item_processor.js*/
    itemDataProcessing: true,
    itemScope: true,
    itemApi: true,
    /*-- user/authorization_contrl.js*/
    AuthorizationCtrl: true,
    authService: true,
    authApi: true,
    /*-- storage/main_storage.js*/
    storage: true,
    /*-- gui/gh_itemUpdate.js*/
    ghItemUpdate: true
  },
  sentry_dsn: SENTRY_DSN,
  show_app_constructor: SHOW_APP_CONSTRUCTOR == WEBPACK_DEFINE_PLUGIN_TRUE,
  show_invite_button: SHOW_INVITE_BUTTON == WEBPACK_DEFINE_PLUGIN_TRUE,
  show_conversations: SHOW_CONVERSATIONS == WEBPACK_DEFINE_PLUGIN_TRUE,
  agent_feature_active: AGENT_FEATURE_ACTIVE == WEBPACK_DEFINE_PLUGIN_TRUE,
  logo_id: LOGO_ID,
  saas_mode: SAAS_MODE == WEBPACK_DEFINE_PLUGIN_TRUE,
  website_url: GUDHUB_WEBSITE_SCHEME + '://' + GUDHUB_WEBSITE_URL,
  mcp_services_url: GUDHUB_NODE_SERVICES_SCHEME + '://' + GUDHUB_SERVER_API_HOST + MCP_SERVICES_API_PATH,
  mcp_core_url: GUDHUB_NODE_SERVICES_SCHEME + '://' + GUDHUB_SERVER_API_HOST + MCP_CORE_API_PATH,
  conversation_server_url: GUDHUB_CONVERSATION_SERVER_URL,
  agents_server_url: GUDHUB_AGENTS_SERVER_URL,
  git_server_url: GUDHUB_GIT_SERVER_URL,
  deployment_manager_server_url: GUDHUB_DEPLOYMENT_MANAGER_SERVER_URL,
  sip_server_url: GUDHUB_SIP_SERVER_URL,
  sip_domain: GUDHUB_SIP_DOMAIN,
  sip_ws_uri: GUDHUB_SIP_WS_URI,
  sip_digest_shared_secret: GUDHUB_SIP_DIGEST_SHARED_SECRET,
};
